module.exports = __webpack_public_path__ + "static/media/type-spectacle.b200917e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/type-spectacle.svg
// module id = 121
// module chunks = 0